import React, { createRef, useEffect, useState } from "react";
import { getAngleBracketSignIfExists, getFormmatedDate, getProperValueFromPoint } from "../../utils/helper";

import "./styles/PreviewChart.css";
import scoreBarSrc from '../../assets/score-bar.png'

const PreviewChart = ({
  datePointsTable,
  previewChartContainerCssClass,
  masterCssClassName
}: any) => {
  const [pointRefs, setPointRefs] = useState<any>([]);
  const [pointLines, setPointLines] = useState<any>([]);
  const [datePointsChart, setDatePointsChart] = useState<any[]>([]); //[...datePointsTable]

  const rowHeightRef = createRef<HTMLDivElement>();

  useEffect(() => {
    console.log("datePointsChart.length: ", datePointsChart);
    setPointRefs((prevRefs: any) =>
      Array(datePointsChart.length)
        .fill(0)
        .map((_, i) => prevRefs[i] || createRef())
    );
  }, [datePointsChart]);

  useEffect(() => {
    if (datePointsTable.length <= 8) {
      setDatePointsChart(datePointsTable);
    } else {
      setDatePointsChart(datePointsTable.slice(-8));
    }
    /* testing data start */ /*
    const points = [50, 56, 45, 5700, 120, '-', 167, 633]
    const modified = points.slice(-8).map((item: any, index: number) => ({
      ...item,
      point: points[index],
      date: new Date()
    }))
    setDatePointsChart(modified); */
    /* testing data end */
  }, [datePointsTable]);

  useEffect(() => {
    newDrawer();
  }, [pointRefs]);

  // as from new design, the lines are reomved
  const newDrawer = () => {
    const isApi = masterCssClassName === 'report-preveiw-api'
    if (pointRefs.length < 2) {
      return;
    }

    const tempLines = [];
    for (let _in = 0; _in < pointRefs.length - 1; ++_in) {
      // if (_in !== 0) break
      let elem1 = pointRefs[_in].current;
      let elem2 = pointRefs[_in + 1].current;
      // const elemContent1 = elem1.querySelector('span')?.textContent || ''
      // const elemContent2 = elem2.querySelector('span')?.textContent || ''
      // console.log("drawer elemContent1: ", elemContent1);

      const rect1 = elem1.getBoundingClientRect();
      const off1 = {
        right: rect1.right + window.pageXOffset,
        top: rect1.top + window.pageYOffset,
        width: rect1.width || elem1.offsetWidth,
        height: rect1.height || elem1.offsetHeight,
      };
      const rect2 = elem2.getBoundingClientRect();
      const off2 = {
        left: rect2.left + window.pageXOffset,
        top: rect2.top + window.pageYOffset,
        width: rect2.width || elem2.offsetWidth,
        height: rect2.height || elem2.offsetHeight,
      };

      // console.log('drawer offset1: ', off1)
      // console.log('drawer offset2: ', off2)
      // console.log('drawer rect1.left: ', rect1.left)
      // console.log('drawer rect1.left: ', rect1.left)
      // console.log('drawer rect2.left: ', rect2.left)

      const thickness = 1;

      const x1 = off1.right - 1; // + off1.width / 2.0
      const y1 = off1.top + off1.height / 2.0;
      // top right
      const x2 = off2.left + 1; // + off2.width / 2.0
      const y2 = off2.top + off2.height / 2.0;

      // distance
      const length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1) * 1.0) + 4;
      // console.log('length: ', length)
      // angle
      const angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI) * 1.0 + 180;

      let cx = 33 // 33.5; //
      if (isApi) {
        cx = 46
      }

      let cy = parseFloat(elem1.style.top.slice(0, -2))
      if (isApi) {
        cy += 14
      } else {
        cy += 11
      }
      // console.log("drawer cx, cy: ", cx, cy);



      const elem1HasAngleBrackets = elem1.innerText.includes("<") || elem1.innerText.includes(">");
      const elem2HasAngleBrackets = elem2.innerText.includes("<") || elem2.innerText.includes(">");
      const textLen1 = elem1.innerText.length
      const textLen2 = elem2.innerText.length

      if (elem1.innerText === '-' && elem2HasAngleBrackets) {
        cx -= isApi ? 7 : 5
      } else if (elem1.innerText === '-') {
        cx -= isApi ? 3 : -3
      }

      if (elem1HasAngleBrackets && elem2HasAngleBrackets) {
        // cx += isApi ? 0 : 3;
        if (textLen1 === 5 && textLen2 === 5) {
          cx += isApi ? 3 : 3;
        } else if (textLen1 === 5 && textLen2 === 3) {
          cx += 5;
        } else if (textLen1 === 3 && textLen2 === 5) {
          cx += isApi ? 1 : 2;
        }
      } else if (elem1HasAngleBrackets && !elem2HasAngleBrackets) {
        if (isApi) {
          if (elem1.innerText.includes("<")) {
            cx += 1;
          } else if (elem1.innerText.includes(">")) {
            cx += 6;
          }
        } else { // for frontend report
          if (elem1.innerText.includes("<")) {
            cx += 1;
          } else if (elem1.innerText.includes(">")) {
            cx += 5;
          }
        }
      } else if (!elem1HasAngleBrackets && elem2HasAngleBrackets) {
        if (isApi) {

          if (elem2.innerText.includes("<")) {
            if (textLen1 === 2 && textLen2 === 3) {
              cx += -2
            } else {
              cx += 2;
            }
          } else if (elem2.innerText.includes(">")) {

            if (textLen1 === 4) {
              cx += 3
            } else if (textLen1 === 3) {
              cx += 1
            } else {
              cx += -2;
            }
          }
        } else {
          if (elem2.innerText.includes("<")) {
            if (textLen1 === 2 && textLen2 === 3) {
              cx += 0
            } else {
              cx += 3;
            }

          } else if (elem2.innerText.includes(">")) {
            if (textLen1 === 4) {
              cx += 3
            }
          }
        }
      } else if (textLen1 === 2 && textLen2 === 2) {
        cx += isApi ? -2 : 0
      } else if (textLen1 === 2 && textLen2 === 3) {
        cx += isApi ? -3 : 0
      } else if (textLen1 === 2 && textLen2 === 4) {
        cx += isApi ? -2 : -1
      } else if (textLen1 === 3 && textLen2 === 3) {
        cx += isApi ? 1 : 2
      } else if (textLen1 === 4 && textLen2 === 2) {
        cx += isApi ? 4 : 3
      } else if (textLen1 === 4 && textLen2 === 3) {
        cx += isApi ? 3 : 3
      } else if (textLen1 === 4 && textLen2 === 4) {
        cx += isApi ? 2 : 2
      }



      const htmlLine = (
        <div
          style={{
            position: "absolute",
            top: cy + "px",
            left: cx + "px",
            padding: "0",
            height: thickness + "px",
            width: length + "px",
            transform: "rotate(" + angle + "deg)",
            transformOrigin: "0 0",

            backgroundColor: "rgb(0, 58, 93)",
            lineHeight: "1px",
          }}
        ></div>
      );

      tempLines.push(htmlLine);
      // console.log("\n");
    }

    setPointLines(tempLines);
  };

  const getCalculatedTop = (_point: any) => {

    const isApi = masterCssClassName === 'report-preveiw-api'
    let topPx = isApi ? -35 : -28 // -24.5; // -24.5
    // console.log('point: ', _point)
    if (_point === '-') {
      topPx += 0;
    }

    const point = _point === '>2000' ? 2001 : _point

    if (typeof point === 'string') {
      if (_point === '<50') {
        topPx -= 0
      } else if (_point === '<100') {
        topPx -= isApi ? 19 : 12
      }
    }

    if (point >= 50) {
      topPx -= 8;
    } else {
      topPx -= 3;
    }
    if (point > 50) {
      const gap = isApi ? 38 : 28
      const result: number = Math.min(gap, ((point - 50) / 100.0) * gap);
      let high = parseFloat(result.toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 100) {
      const gap = 1
      const result: number = Math.min(gap, ((point - 100) / 100.0) * gap);
      let high = parseFloat(result.toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 150) {
      const gap = isApi ? 36 : 30
      let high = parseFloat(Math.min(gap, ((point - 150) / 100.0) * gap).toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 200) {
      const gap = isApi ? 4 : 2
      let high = parseFloat(Math.min(gap, ((point - 200) / 100.0) * gap).toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 250) {
      const gap = isApi ? 24 : 16
      let high = parseFloat(Math.min(gap, ((point - 250) / 250.0) * gap).toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 500) {
      const gap = isApi ? 31 : 25
      let high = parseFloat(Math.min(gap, ((point - 500) / 500.0) * gap).toString()); //.toFixed(2)
      topPx -= high;
    }
    if (point > 1000) {
      const gap = isApi ? 60 : 50
      let high = parseFloat(Math.min(gap, ((point - 1000) / 1000.0) * gap).toString()); //.toFixed(2)
      topPx -= high;
    }
    // if (point > 1000) {
    //   const gap = isApi ? 63 : 50
    //   let high = parseFloat(Math.min(gap, ((point - 1000) / 1000.0) * gap).toString()); //.toFixed(2)
    //   topPx -= high;
    // }


    if (point > 2000) {
      topPx -= 5

    }




    return topPx + "px";
  };

  return (
    <div className={previewChartContainerCssClass}>
      <div className="bottom-line"></div>
      <div className="box-header chart-header">
        <span>Thymidine Kinase activity (TKa)</span>
      </div>
      <div className="score-bar">
        <img src={scoreBarSrc} alt="Score-Bar" />
      </div>
      <div className="main-chart">
        <div className="main-chart-row row-item-2000" ref={rowHeightRef}>
          <div className="row-item-left">
            <span>2000</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-1500">
          <div className="row-item-left">
            <span>1500</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-1000">
          <div className="row-item-left">
            <span>1000</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-500">
          <div className="row-item-left">
            <span>500</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-250">
          <div className="row-item-left">
            <div className="dotted-line">
              <div className="border-elem"></div>
            </div>
            <span>250</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-200">
          <div className="row-item-left">
            <span>200</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-150">
          <div className="row-item-left">
            <span>150</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-100">
          <div className="row-item-left">
            <span>100</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-50">
          <div className="row-item-left">
            <span>50</span>
          </div>
          <div className="row-item-right"></div>
        </div>
        <div className="main-chart-row row-item-0">
          <div className="row-item-left">
            <span>0</span>
          </div>
        </div>

        <div className="y-legend">
          <span>DuA</span>
        </div>

        <div className="left-bar"></div>
        <div className="bottom-bar"></div>
      </div>
      <div className="datepoint-container">
        <div className="date-legend">
          <span>
            <strong>DATE:</strong>
          </span>
        </div>

        {datePointsChart.map((_datePoint, _in) => {
          const _floatPointStr = getProperValueFromPoint(_datePoint.point);


          return (
            <div className={`datepoint-item datepoint-item-loop datepoint-item-${_in + 1}`} key={_in}>
              <span>{getFormmatedDate(_datePoint.date)}</span>
              <span className="day-cycle">{_datePoint.dayCycle}</span>
              <div
                className={`point point-${_in}`}
                ref={pointRefs[_in]}
                style={{
                  top: getCalculatedTop(_datePoint.point),
                  textAlign: 'center',
                  minWidth: '23px',
                  backgroundColor: _in === datePointsChart.length - 1 ? "#FEFBD1" : "#FFFFFF",
                }}
              >
                <span>{_floatPointStr}</span>
              </div>
              {pointLines[_in] || null}
              {_in === datePointsChart.length - 1 && <div className={`last-box last-box-${_in}`}></div>}
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default PreviewChart;
